<template>
  <div class="replenishment">
    <tips class="replenishment-tip">
      <div class="replenishment-tip__line"> 亚马逊卖家经常会遇到一天或几天内“创建多个进仓计划单”的情况,“一个进仓计划单的产品"可能由“多个供应商提供”,或“不同进仓计划单的产品”可能由“相同的供应商提供”。因些在进仓计划单创建后, </div>
      <div class="replenishment-tip__line"> 可点击“新建采购计划”按钮, 系统将“根据产品所属不同的供应商,智能分拆并合并成不同的采购计划单”（提示：剩余不符合合并条件的单个产品也将自动“单独生成”采购计划单，完成进仓单的采购计划。 </div>
    </tips>
    <div class="replenishment-top">
      <div class="replenishment-top__name">FBA发补货计划单</div>
      <div class="replenishment-top__fun">
        <div class="replenishment-top-item">
          <div class="replenishment-top-item__name">店铺:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="replenishment-top-item replenishment-top-item--date">
          <div class="replenishment-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="replenishment-top-item replenishment-top-item--date">
          <div class="replenishment-top-item__name">要求交货日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="replenishment-top-item">
          <div class="replenishment-top-item__name">状态:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="replenishment-top-item replenishment-top-item--input">
          <el-input size="mini" placeholder="请输入客户名称/单号/国家等"></el-input>
        </div>
        <div class="replenishment-top__btn">搜索</div>
        <div class="replenishment-top__btn" @click="newReplenishmentBtnClick">新建发补货计划单</div>
      </div>
    </div>
    <div class="replenishment-table">
      <Table :head="tableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ReplenishmentNewModule, ReplenishmentSearchData } from './class'
import tips from '../common/tips.vue';
import Table from 'components/common/Table.vue'
export default {
  name: 'FBAReplenishment',
  components: {
    tips, Table
  },
  data(){
    return{
      /**搜索数据 */
      searchData: new ReplenishmentSearchData(),
      /**表头 */
      tableHead: ReplenishmentNewModule.NEWTABLEHEAD()
    }
  },
  methods: {
    /**新建发补货计划单 */
    newReplenishmentBtnClick(){
      this.$emit('go', {
        id: 'newFBAReplenishment',
        name: '新建发补货计划单',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.replenishment{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 200px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
